<template>
    <div class="container">
        <navigation />

        <div class="row">
            <div class="col-12 text-left">
                <a @click="$router.go(-1)" class="btn btn-link btn-back-link">&laquo; Back</a>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h1>Link Cards</h1>
            </div>
        </div>

        <div class="row" v-if="errorMessages.length > 0">
            <div class="col-12">
                <div v-for="error in errorMessages" v-bind:key="error">
                    <div class="alert alert-danger">
                        {{error}}
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div v-for="error in errorMessages" v-bind:key="error">
                    <div class="alert alert-danger">
                        {{error}}
                    </div>
                </div>
                <form v-on:submit="onSubmit">
                    <p class="small">* Indicates a required field</p>
                    <div class="row form-group">
                        <div class="col-xs-12 col-sm-6 col-md-4">
                            <input type="text" class="form-control" name="cardNumber" placeholder="*Card Number" v-model="cardNumber">
                        </div>
                    </div>
                    <button type="submit" class="btn btn-primary btn-bellstores" :disabled="!isValid">Link Card</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import APIResponseError from '@/models/responses/APIResponseError'
import APIRequestError from '@/models/responses/APIRequestError'

export default {
    name: 'LinkCard',
    dependencies: ['apiService', 'storageService'],
    data () {
        return {
            cardNumber: '',
            errorMessages: []
        }
    },
    async mounted () {

    },
    computed: {
        isValid () {
            return this.cardNumber !== ''
        }
    },
    methods: {
        async onSubmit (e) {
            e.preventDefault()
            this.errorMessages = []
            this.successMessages = []
            const response = await this.apiService.linkCard(this.cardNumber)

            if (response instanceof APIRequestError || response instanceof APIResponseError) {
                this.errorMessages.push(response.message())
                return
            }

            this.$router.push({ name: 'ManageCards' })
        }
    }
}
</script>

<style scoped lang="scss">
    .btn-yes {
        margin-left: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/components/LinkCard.vue